var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcbroLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 854.05042 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00eaea;}.cls-2{fill:#00d2ff;}.cls-3{fill:#009fff;}.cls-4{fill:#0078ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_certa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.5,200.5a299.06121,299.06121,0,0,1,212.132,87.868l141.4184-141.4184A498.43932,498.43932,0,0,0,573,0C420.17023,0,283.359,68.57123,191.64435,176.622l153.27612,129.6026A299.32,299.32,0,0,1,573.5,200.5Z",
    transform: "translate(-73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.5,500.5a298.7889,298.7889,0,0,1,71.42047-194.27539L191.64435,176.622A500.19181,500.19181,0,0,0,147.338,762.43646l170.37738-105.1206A298.57928,298.57928,0,0,1,273.5,500.5Z",
    transform: "translate(-73)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M573.5,800.5c-108.2016,0-203.01245-57.29053-255.78461-143.18414L147.338,762.43646C235.42047,904.999,393.11292,1000,573,1000q17.09317,0,33.90491-1.13959L593.58966,799.81488C586.94781,800.25415,580.25305,800.5,573.5,800.5Z",
    transform: "translate(-73)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M593.58966,799.81488l13.31525,199.04553a498.37844,498.37844,0,0,0,319.6485-145.307L785.632,712.632A299.0202,299.0202,0,0,1,593.58966,799.81488Z",
    transform: "translate(-73)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcbroLogo);
export default __webpack_public_path__ + "static/media/calcbro-logo.b7542681e81334e13759413f3aed178d.svg";
export { ForwardRef as ReactComponent };